import { TextField } from '@mui/material';
import SpinnerButton from '../../../components/SpinnerButton';
import { useNewPassword } from '../hooks/useNewPassword';
import { APP_LABELS, RESET_PASSWORD_LABELS } from '../../../utils/labels';

export default function ResetPasswordPage() {
  const {
    password,
    setPassword,
    confirm,
    setConfirm,
    error,
    loading,
    ready,
    submit,
  } = useNewPassword();

  if (!ready) return null;

  return (
    <div className="min-h-dvh flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mb-3 flex justify-center">
            <img src="/planly-logo-light.svg" alt={APP_LABELS.appName} className="h-16 w-auto dark:hidden" />
            <img src="/planly-logo-dark.svg" alt={APP_LABELS.appName} className="h-16 w-auto hidden dark:block" />
          </div>
          <p className="text-sm text-text-secondary">{RESET_PASSWORD_LABELS.welcome}</p>
        </div>

        <div className="rounded-2xl border border-border bg-surface">
          <div className="p-8">
            <form onSubmit={submit} className="flex flex-col gap-5" noValidate>
              <TextField
                label={RESET_PASSWORD_LABELS.passwordLabel}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                fullWidth
                helperText={RESET_PASSWORD_LABELS.passwordHint}
              />
              <TextField
                label={RESET_PASSWORD_LABELS.confirmLabel}
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                fullWidth
              />

              {error && (
                <p
                  role="alert"
                  className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
                >
                  {error}
                </p>
              )}

              <SpinnerButton type="submit" variant="contained" fullWidth loading={loading}>
                {RESET_PASSWORD_LABELS.submitButton}
              </SpinnerButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
